import React from 'react';

type Props = {
  audio?: string;
};

const Voice = ({ audio }: Props) => {
  return (
    <>
      <audio src={audio} controls controlsList="nodownload nofullscreen"></audio>
    </>
  );
}

export default Voice;